// extracted by mini-css-extract-plugin
module.exports = {"text-input":"style_text-input__2jiDs","input-wrapper":"style_input-wrapper__a_kfg","with-value":"style_with-value__1kFed"};